import * as React from "react";

export const HeatmapLegend = () => (
  <div style={{ display: "inline-block" }}>
    <div
      style={{
        textAlign: "center",
        marginTop: 2,
        paddingTop: 10,
        paddingBottom: 3,
        paddingLeft: 12,
        paddingRight: 12,
        backgroundColor: "white",
        borderRadius: 3,
        border: "1px solid #E4E4E4"
      }}
    >
      <div style={{ width: "100%", fontSize: 11 }}>
        <span style={{ float: "left" }}>low</span>
        <span style={{ float: "right" }}>high</span>
      </div>
      <svg xmlns="http://www.w3.org/2000/svg" width={150} height={10}>
        <defs>
          <linearGradient id="lgrad" x1="0%" y1="50%" x2="100%" y2="50%">
            <stop
              offset="0%"
              style={{ stopColor: "rgb(0,0,255)", stopOpacity: 1 }}
            />
            <stop
              offset="25%"
              style={{ stopColor: "rgb(0,255,255)", stopOpacity: 1 }}
            />
            <stop
              offset="50%"
              style={{ stopColor: "rgb(0,255,0)", stopOpacity: 1 }}
            />
            <stop
              offset="75%"
              style={{ stopColor: "rgb(255,226,3)", stopOpacity: 1 }}
            />
            <stop
              offset="100%"
              style={{ stopColor: "rgb(255,2,2)", stopOpacity: 1 }}
            />
          </linearGradient>
        </defs>
        <rect
          x="0"
          y="0"
          width="100%"
          height="100%"
          fill="url(#lgrad)"
          rx={3}
          ry={3}
        />
      </svg>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./client/modules/core/Chart/Heatmap/HeatmapLegend.tsx